/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ProcessingMode } from './processingMode';

export type ProcessingOptionsProcessorModes = { [key: string]: ProcessingMode };
